import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { OrderTrigger } from '@frontend/order/types';
import { WorkflowTrigger } from '@frontend/workflow/types';

const ID = 'order-trigger-select';

export interface OrderTriggerSelectProps extends Omit<SelectInputV2Props<string>, 'options'> {}

export const OrderTriggerSelect = (props: OrderTriggerSelectProps) => (
    <SelectInputV2
        {...props}
        id={ID + props.id}
        label={props.label || 'Order trigger'}
        options={[...OrderTrigger.ALL, ...WorkflowTrigger.ALL].map((trigger) => ({ value: trigger.value, label: trigger.value, display: trigger.displayName }))}
    />
);

export default OrderTriggerSelect;
